import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    marginBottom: 20
  },
  subtitle: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 10
  },
  table: {
    display: 'table',
    width: 'auto',
    margin: 'auto'
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableHeader: {
    backgroundColor: '#E4E4E4',
    fontWeight: 'bold'
  },
  tableCell: {
    margin: 'auto',
    marginTop: 5,
    marginBottom: 5,
    fontSize: 12,
    padding: 5,
    borderWidth: 1,
    borderColor: '#AAAAAA',
    backgroundColor: '#FFFFFF'
  }
});

// Create Document Component
const MyDocument = ({ data }) => (
  <Document>
    <Page style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.title}>Ticket List</Text>
        <Text style={styles.subtitle}>Exported on: {new Date().toLocaleString()}</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, styles.tableHeader]}>
            {
              data.lenght!=null?
              Object.keys(data[0]).map(key => (
              <Text style={styles.tableCell} key={key}>{key}</Text>
            ))
            :
            null
            }
          </View>
          {
            data.lenght!=null?
            data.map((ticket, i) => (
            <View style={styles.tableRow} key={i}>
              {Object.keys(ticket).map(key => (
                <Text style={styles.tableCell} key={key}>{ticket[key]}</Text>
              ))}
            </View>
          ))
          :
          null
          }
        </View>
      </View>
    </Page>
  </Document>
);

export { MyDocument };
